import { AppConfig, authApi } from '@app/services/auth';
import { runIfFn } from '@chakra-ui/theme-tools';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';
import { LIXI_BAG } from '@constants';
type AppConfigState = AppConfig;

const slice = createSlice({
  name: 'appConfig',
  initialState: null as AppConfigState | null,
  reducers: {
    setAppConfig: (state, payload: PayloadAction<AppConfig | null>) => {
      if (!payload) {
        state = payload;
      }
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      authApi.endpoints.getAppConfig.matchFulfilled,
      (state, { payload }) => {
        return payload.getAppConfig;
      },
    );
  },
});

export default slice.reducer;

export const { setAppConfig } = slice.actions;
export const selectAppConfig = ({ appConfig }: RootState) => appConfig;
export const selectCurrentLixiBagAddress = ({ appConfig }: RootState) =>
  (appConfig || {}).lixiBagAddress || LIXI_BAG;
